/*
* cc-stageHero
*/

const ccStageHero = {
    cfg:  {
        name: 'Stage Hero +',
        selectors: {
            root: '.cc-stageHero',
        },
        classes: {
        },
        el: {
            $root: undefined,
        },
    },

    setElements() {
        this.cfg.el.$root = document.querySelector(this.cfg.selectors.root);
    },

    addEventListeners() {
        const sliderContainer = this.cfg.el.$root.querySelector('.swiper-container');
        this.cfg.el.$root.addEventListener('addPlayer', (e) => {
            const player = e.detail;
            player.on('play', () => {
                sliderContainer.remove();
            });
        })
    },

    init() {
        console.debug(`Init: ${this.cfg.name}`);
        this.setElements();

        if (this.cfg.el.$root) {
            this.addEventListeners();
        }
    },
};

export default ccStageHero;
